<template>
  <div
    class="modal fade bd-example-modal-lg"
    id="hailingModal"
    role="dialog"
    tabindex="-1"
    aria-hidden="true"
    aria-labelledby="exampleModalLabel"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">
            派車後的結果
            <span class="color_red">
              ({{ orderStatusString }}-{{ amountOfSendOrder }})
            </span>
            <span
              :class="isNormalConnect ? 'normal_connect' : 'abnormal_connect'"
            >
              {{ connectStatusString }}
            </span>
          </h3>
          <h4 class="modal-title">
            上車地點:{{ this.hailingBillData.onLocation }}
          </h4>
          <h4 class="modal-title">
            備註:{{ this.hailingBillData.passenComment }}
          </h4>
          <h4 class="modal-title">
            派遣區:{{ this.hailingBillData.dispatchAreaName }}
          </h4>
          <h4 class="modal-title color_red" v-if="finishHailing">
            {{ state }}
          </h4>
          <h4 class="modal-title color_red" v-else-if="timeNumber === 0">
            等待伺服器回傳訂單編號中...
          </h4>
          <h4 class="modal-title color_red" v-else>
            {{
              timeNumber === 60
                ? '結束派遣（若資料尚未呈現，請稍候3-5秒）'
                : `派遣中${timeNumber}秒`
            }}
          </h4>
          <button class="close" @click="closeHailingResult">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <HailingResult
            ref="hailingResult"
            v-show="state !== '取消完成'"
            :immediatelyNonTaxi="immediatelyNonTaxi"
            :immediatelyHailingCars="immediatelyHailingCars"
            :hailingResultArray="hailingResultArray"
            :initalHailingBillData="hailingBillData"
            :orderIDArray="orderIDArray"
            :showHailingAgain="finishHailing"
            :passengerComment="hailingBillData.passenComment"
            @recall="recallHailing"
            @afterCancelRefresh="refreshAfterCancelCar"
            @beforeCancel="beforeCancelAction"
            @sendSns="sendSnsAction"
            @grabPhone="setContactPhoneInNote"
            @cancelOrderFlag="cancelOrderFlag"
          ></HailingResult>
        </div>
        <div class="modal-body">
          <h4 class="modal-title color_red">以下是尋車結果</h4>
          <SearchTaxiResult
            :driverStatusList="driverStatusList"
          ></SearchTaxiResult>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeHailingResult">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import API from '../../assets/js/libs/API'
import HailingResult from './PhoneHailResultList'
import SearchTaxiResult from './SearchTaxiResult'
// import notification from "../../assets/js/tool/notificaiton.js";
import BehaviorRecorder from '../../assets/js/libs/BehaviorRecorder'

export default {
  name: 'hailResultModal',
  props: [
    'customerPhone',
    'contactPhone',
    'orderIDArray',
    'hailingBillData', // 訂單資料
    'hasSendCar',
    'isServerCheckReceiveOrder',
    'amountOfSendOrder',
    'staffHailATaxiMark',
    'deleteMark',
  ],
  data() {
    return {
      timeNumber: 0,
      timeNumberShift: 0,
      stopTime: false,
      stopShiftTime: false,
      driverStatusList: [],
      state: '',
      finishHailing: false,
      hailingResultArray: [],
      immediatelyNonTaxi: false,
      immediatelyHailingCars: false,
      count: 0,
      failCount: 0,
      noReplyList: [],
      intervalId: null,
      /* shift: {
        callNumber: "",
        phone: ""
      }, */
      isNormalConnect: true,
      isCancelOrder: false,
    }
  },
  computed: {
    connectStatusString() {
      return this.isNormalConnect ? '連線正常' : '連線異常'
    },
    orderStatusString() {
      return this.isServerCheckReceiveOrder ? '已發送訂單' : '訂單未發送'
    },
  },
  methods: {
    sendSnsAction(item) {
      this.$emit('sendSnsAction', item)
    },
    initialData() {
      this.state = '結束派遣（若資料尚未呈現，請稍候3-5秒）'
      this.finishHailing = false
      this.driverStatusList = []
      this.$refs.hailingResult.clearData()
      this.immediatelyNonTaxi = false
      this.immediatelyHailingCars = false
      $('#hailingModal').modal('hide')
      this.$emit('releaseHaveSendedOrderCondition')
    },
    initialDataWithoutHideModal() {
      this.state = '結束派遣（若資料尚未呈現，請稍候3-5秒）'
      this.finishHailing = false
      this.driverStatusList = []
      this.$refs.hailingResult.clearData()
      this.immediatelyNonTaxi = false
      this.immediatelyHailingCars = false
      this.$emit('releaseHaveSendedOrderCondition')
    },
    cancelOrderFlag() {
      this.isCancelOrder = true
    },
    closeHailingResult() {
      this.$msg('查詢此訂單是否結束')
      BehaviorRecorder.record('點擊', '派車頁面', '尋車中: 點選關閉視窗')
      /* 若有order id表示尋車已經結束直接初始化資料
      若無則表示還在倒數中，需要增加alert讓使用者確認 */
      if (this.orderIDArray[0] || this.isCancelOrder) {
        this.initialData()
      } else {
        if (confirm('派車單尋車中，確定關閉嗎？')) {
          this.$bus.$emit('closeModal', false)
          this.initialData()
          BehaviorRecorder.record(
            '點擊',
            '派車頁面',
            '尋車中: 點選確定關閉視窗',
          )
        }
      }
      this.stopCountTime()
      this.stopCountShiftTime()
      this.noReplyList = []
      // 刪除delete mark
      if (typeof this.deleteMark === 'string') {
        this.$emit('reqDeleteOrderMark', this.deleteMark)
      } else {
        this.deleteMark.map((mark) => this.$emit('reqDeleteOrderMark', mark))
      }
      /* API.get(`bill/state/?id=${this.orderIDArray[0]}`)
        .then(res => {
          BehaviorRecorder.record(
            "點擊",
            "派車頁面",
            "尋車中: 點選關閉視窗" + res.result
          );
          if (res.success && res.result === "訂單未結束") {
            if (confirm("派車單詢車中，確定關閉嗎？")) {
              this.$bus.$emit("closeModal", false);
              this.initialData();
              this.stopCountTime();
              BehaviorRecorder.record(
                "點擊",
                "派車頁面",
                "尋車中: 點選確定關閉視窗"
              );
            }
            return;
          }
          this.initialData();
        })
        .catch(() => {
          this.$msg("網路連線不穩，請在操作一次");
        }); */
    },
    setConnectionState(val) {
      this.isNormalConnect = val
    },
    deliverySocket(socket) {
      this.$refs.hailingResult.deliverySocket(socket)
    },
    openModal() {
      $('#hailingModal').modal({
        backdrop: 'static',
        keyboard: true,
      })
      this.setContactPhoneInNote()
    },
    setContactPhoneInNote() {
      const phone =
        !this.contactPhone || this.contactPhone === ''
          ? this.customerPhone
          : this.contactPhone
      this.$refs.hailingResult.setContactPhoneInNote(phone)
    },
    recallHailing(value) {
      if (this.hasSendCar && !confirm('訂單已送出是否還要再派一次')) return
      this.initialData()
      this.$emit('recallHailing', value)
    },
    refreshAfterCancelCar() {
      this.state = '取消完成'
      this.clearHailingResultArray()
    },
    beforeCancelAction(result) {
      this.state = '取消完成'
      this.$emit('beforeCancel', result)
    },
    deliveryMessageToManyDriver(val) {
      this.$refs.hailingResult.sendNoteToManyDriver(val)
    },
    counterShift() {
      if (this.stopShiftTime) {
        this.timeoutShift = null
        clearInterval(this.intervalId)
      } else if (this.timeNumberShift < 16) {
        this.timeNumberShift += 1
      } else {
        // HACK: 空派單不會跳出通知
        this.noReplyList
          .filter((shiftInfo) => shiftInfo.dispatchMethod !== '空派')
          .map((shiftInfo, idx) => {
            this.$notify({
              dangerouslyUseHTMLString: true,
              title: `司機排班未回覆`,
              message: `司機呼號:${shiftInfo.callNumber}<br/>司機電話:${shiftInfo.phone}<br/>乘客地點:${this.hailingBillData.onLocation}`,
              type: 'warning',
              position: 'bottom-right',
              duration: 0,
              offset: idx * 120, // 增加偏移量讓訊息不會重疊
            })
          })
        this.stopCountShiftTime()
      }
    },
    startCountShiftTime() {
      this.stopShiftTime = false
      this.intervalId = setInterval(this.counterShift, 1000)
    },
    stopCountShiftTime() {
      this.stopShiftTime = true
      this.timeNumberShift = 0
    },
    stopCountTime() {
      this.stopTime = true
      this.timeNumber = 0
    },
    startCountTime(isServerCheckReceiveOrder) {
      if (isServerCheckReceiveOrder) {
        this.stopTime = false
        this.counter()
      }
    },
    counter() {
      if (this.stopTime) {
        this.timeout = null
      } else if (this.timeNumber < 60) {
        this.timeout = setTimeout(this.counter, 1000)
        this.timeNumber += 1
      } else {
        this.stopTime = false
      }

      const statusRequiredTimrer = [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
      if (statusRequiredTimrer.includes(this.timeNumber)) {
        this.getDriverCarStatus()
      }
    },
    getDriverCarStatus(val) {
      if (val !== 0 && this.orderIDArray.length === 1) {
        API.get(`status/driverlist/?orderid=${this.orderIDArray[0]}`)
          .then((res) => {
            this.driverStatusList = res.result
          })
          .catch((e) => {
            console.error(e)
          })
      }
    },
    hailingTaxiResult(res) {
      // 當此訂單是排班兩輪或是空派
      if (res.shiftProgram === 1 || !res.shiftProgram) {
        this.noReplyList.push({
          callNumber: res.driverCallNumber,
          phone: res.driverPhoneNumber,
          dispatchMethod: res.dispatchMethod,
        })
        if (this.hailingBillData.cars === 1) {
          this.startCountShiftTime()
        } else if (this.noReplyList.length === this.hailingBillData.cars) {
          this.startCountShiftTime()
        }
      }
      // 間接替代掉LineUpOrderNotify的socket event
      if (res.driverReceivedNotify) {
        this.stopCountShiftTime()
        const msg = `呼號/編號:${res.driverCallNumber}，司機已看到訂單並按確認`
        if (Cookies.get('GladTeamCode') === '888') {
          this.$msg(msg)
        } else {
          alert(msg)
        }
      }
      this.hailingBillData.cars === 1
        ? this.handleSingleHailingResult(res)
        : this.handlePluralHailingResult(res)
    },
    handleSingleHailingResult(res) {
      this.stopCountTime()
      this.finishHailing = true
      /* if (res.result === "中斷叫車") return alert("中斷成功");
      if (res.result === "無車輛可派。") {
        this.hailingResultArray.push(res);
        this.getDriverCarStatus(0);
        this.immediatelyNonTaxi = true;
        return;
      }
      if (this.count === 0) {
        this.count = +1;
        this.hailingResultArray.push(res.result);
        this.getDriverCarStatus(1);
      } */
      if (res.orderStatus === '中斷叫車') return alert('取消成功')
      if (res.orderStatus === '無車輛可派。') {
        this.hailingResultArray.push(res)
        this.getDriverCarStatus(0)
        this.immediatelyNonTaxi = true
        return
      }
      if (this.count === 0) {
        this.count = +1
        this.hailingResultArray.push(res)
        this.getDriverCarStatus(1)
      }
    },
    async handlePluralHailingResult(res) {
      let orderID = []
      // console.log(res);
      // HACK:
      // 加入以下程式多台車若倒數時按下中心取消可取消訂單並且停止倒數
      /* this.stopCountTime();
      this.finishHailing = true; */

      /* if (res.result === "無車輛可派。") {
        this.hailingResultArray.push(res);
        this.failCount += 1;
      } else {
        this.hailingResultArray.push(res.result);
      }

      if (this.hailingResultArray.length === this.hailingBillData.cars) {
        this.finishHailing = true;
        this.stopCountTime();
        if (this.hailingBillData.group_id !== null) {
          await this.updateGroupIdState({
            groupId: this.hailingBillData.group_id,
            failCount: this.failCount,
            cars: this.hailingBillData.cars
          });
        }
      } */
      if (res.orderStatus === '無車輛可派。') {
        this.hailingResultArray.push(res)
        this.failCount += 1
      } else {
        this.hailingResultArray.push(res)
      }

      if (this.hailingResultArray.length === this.hailingBillData.cars) {
        this.finishHailing = true
        this.stopCountTime()
        if (this.hailingBillData.group_id) {
          this.updateGroupIdState({
            groupId: this.hailingBillData.group_id,
            failCount: this.failCount,
            cars: this.hailingBillData.cars,
          })
        }
      }
      this.getDriverCarStatus()
      this.deliveryMessageToManyDriver(orderID.join(','))
    },
    clearHailingResultArray() {
      this.hailingResultArray = []
      this.count = 0
      this.failCount = 0
    },
    setManyCarsState(cars) {
      if (cars !== 1) {
        this.immediatelyHailingCars = true
      }
    },
    updateGroupIdState(payload) {
      API.put('service/callcar/group', payload)
        .then((res) => res.result === '更新group訂單成功')
        .catch(() => false)
    },
  },
  components: {
    HailingResult,
    SearchTaxiResult,
  },
  watch: {
    hailingBillData: {
      handler(newVal) {
        if (newVal && newVal.passenComment) {
          // 監聽備註資料 避免出現 "乘客電話: " 這樣的資料
          // 直接使用 prop 中的 contactPhone
          this.$refs.hailingResult.setContactPhoneInNote(this.contactPhone)
        }
      },
      immediate: true,
    },
  },
}
</script>
<style scoped>
.color_red {
  color: #ff1a1a;
}

.normal_connect {
  background: #adebad;
  color: #3333ff;
  font-size: 16px;
}

.abnormal_connect {
  background: #ff1a1a;
  color: #3333ff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/hailing/HailResultModal.vue